/**
 * PortalsHub (Iter 9.39b)
 *
 * Single home for partner / commission / portal management. Commissions now
 * live inside Advocates (a commission is what an advocate earns).
 * Sub-tabs:
 *   - Advocates (AdminAdvocatesPage, includes commission tracking)
 *   - Pilot (existing PrivatePortalsSection)
 *   - Investors 🔒 (InvestorPortalsPage, password-locked)
 */
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Badge } from "@/components/ui/badge";
import { HeartHandshake, Users, Star, Briefcase, Lock } from "lucide-react";
import AdminAdvocatesPage from "@/pages/admin/AdminAdvocatesPage";
import PrivatePortalsSection from "@/pages/admin/PrivatePortalsSection";
import InvestorPortalsPage from "@/pages/admin/InvestorPortalsPage";
import LockedTab from "@/components/admin/LockedTab";

export default function PortalsHub() {
  const [active, setActive] = useState("advocates");
  return (
    <div data-testid="portals-hub">
      <div className="flex items-center gap-2 mb-4">
        <HeartHandshake className="w-5 h-5" />
        <h1 className="text-xl font-bold">Portals</h1>
        <Badge className="bg-purple-100 text-purple-700 border-0">Advocates · Pilot · Investors</Badge>
      </div>
      <p className="text-xs text-gray-500 mb-4">
        Partner + commission management. Commissions live inside Advocates (commission = advocate earnings).
      </p>
      <Tabs value={active} onValueChange={setActive}>
        <TabsList className="flex-wrap h-auto">
          <TabsTrigger value="advocates" data-testid="portals-tab-advocates">
            <Star className="w-3.5 h-3.5 mr-1" />Advocates
          </TabsTrigger>
          <TabsTrigger value="pilot" data-testid="portals-tab-pilot">
            <Briefcase className="w-3.5 h-3.5 mr-1" />Pilot
          </TabsTrigger>
          <TabsTrigger value="investors" data-testid="portals-tab-investors">
            <Lock className="w-3.5 h-3.5 mr-1" />Investors
          </TabsTrigger>
        </TabsList>
        <TabsContent value="advocates" className="mt-4">
          <AdminAdvocatesPage />
        </TabsContent>
        <TabsContent value="pilot" className="mt-4">
          <PrivatePortalsSection />
        </TabsContent>
        <TabsContent value="investors" className="mt-4">
          <LockedTab
            scope="investors"
            title="Investors portal"
            description="Protected. Enter the admin lock password to view investor management."
            testid="portals-investors-lock"
          >
            <InvestorPortalsPage />
          </LockedTab>
        </TabsContent>
      </Tabs>
    </div>
  );
}
